import React from 'react'
import SimpleScatter from '../statistics/SimpleScatter'
import MainTitle from '../common/MainTitle'
import CustomHr from '../common/CustomHr'
import { H4 } from '@blueprintjs/core'
import { translate } from 'utlis/translations/i18n'

const AttributeScatters = ({ attributes, preferencesData }) => {

    return (
        <div>
            {attributes.map((attr, i) => {
                let data = []
                preferencesData.forEach((image, y) => {
                    data.push({ name: image.name, x: image.Evaluation, y: image.attributes[i].quantity })
                })
                return (
                    <div key={i}>
                        <MainTitle text={`${translate('ratioMeanScoreAttribute')} ${attr.name}`} />
                        <H4 className='text-center margin-bottom-large new-results'>{translate('scatterHover')}</H4>
                        <SimpleScatter
                            key={i}
                            XAxisName={translate('averageScore')}
                            YAxisName={attr.name}
                            XUnit=''
                            YUnit={attr.unit}
                            data={data}
                        />
                        <CustomHr />
                    </div>
                )
            }
            )}
        </div>
    )
}

export default AttributeScatters
